export default {
  clearTip: 'Are you sure you want to clear all contents?',
  btnHeader: 'Header',
  btnClear: 'Clear',
  btnBold: 'Bold',
  btnItalic: 'Italic',
  btnUnderline: 'Underline',
  btnStrikethrough: 'Strikethrough',
  btnUnordered: 'Unordered list',
  btnOrdered: 'Ordered list',
  btnQuote: 'Quote',
  btnLineBreak: 'Line break',
  btnInlineCode: 'Inline code',
  btnCode: 'Code',
  btnTable: 'Table',
  btnImage: 'Image',
  btnLink: 'Link',
  btnUndo: 'Undo',
  btnRedo: 'Redo',
  btnFullScreen: 'Full screen',
  btnExitFullScreen: 'Exit full screen',
  btnModeEditor: 'Only display editor',
  btnModePreview: 'Only display preview',
  btnModeAll: 'Display both editor and preview',
  selectTabMap: 'Actual input when typing a Tab key',
  tab: 'Tab',
  spaces: 'Spaces'
};